import React from 'react';
import PropTypes from 'prop-types';
import inflection from 'inflection';
import TextField from 'material-ui/TextField';
import * as ReactColor from 'react-color';

const style = {
    ColorInputPopup : {
        position: "absolute",
        zIndex: 2,
      },
      ColorInputCover : {
        position: "fixed",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
      }
}

class ColorInput extends React.Component {
  state = {
    show: false
  };

  handleOpen = () => this.setState({ show: true });
  handleClose = () => this.setState({ show: false });
  handleChange = ({ hex }) => {
    this.props.input.onChange(hex);
    this.forceUpdate();
  };

  render() {
    const {
      label,
      source,
      meta,
      elStyle,
      options,
      picker,
      input,
    } = this.props;

    const Picker = ReactColor[`${picker}Picker`];

    return (
      <div>
        <div style={{ display: 'flex' }}>
          <TextField
            {...input}
            onFocus={this.handleOpen}
            floatingLabelText={ label || inflection.humanize(source) }
            errorText={meta.touched && meta.error}
            style={elStyle}
          />
          <div style={{
            width: '30px',
            height: '30px',
            background: input.value,
            marginRight: '5px',
            marginTop: '30px'
          }}
          />
        </div>
        {
          this.state.show?
            <div style={style.ColorInputPopup}>
              <div
                style={style.ColorInputCover}
                onClick={this.handleClose}
              />
              <Picker
                {...options}
                color={input.value}
                onChange={this.handleChange}
              />
            </div>
            : null
        }
      </div>
    )
  }
};

ColorInput.propTypes = {
  addField: PropTypes.bool.isRequired,
  label: PropTypes.string,
  options: PropTypes.object,
  source: PropTypes.string,
  input: PropTypes.object,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
  picker: (props, propName, componentName) =>
    !ReactColor[`${props[propName]}Picker`] &&
    new Error(`Invalid prop \`${propName}\` supplied to \`${componentName}\`.`)
};

ColorInput.defaultProps = {
  addField: true,
  picker: 'Chrome',
  options: {
    disableAlpha: true
  },
};

export default ColorInput;



// WEBPACK FOOTER //
// ./src/components/ColorInput.js